// src/pages/account/DeleteAccount.js
import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../context/UserContext';
import { NotificationContext } from '../../context/NotificationContext';
import { BASE_URL } from '../../utils/config'; // Import Role enum
import { apiFetch } from '../../utils/apiClient';
import { useLanguage } from '../../hooks/useLanguage';
import './DeleteAccount.css'; // New CSS file

const DeleteAccount = () => {
  const { t } = useTranslation();
  const { user, logoutUser } = useContext(UserContext);
  const { addNotification } = useContext(NotificationContext);
  const navigate = useNavigate();

  const lang = useLanguage();
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const proceedWithDeletion = async () => {
    setIsSubmitting(true);
    try {
      const response = await apiFetch(
        `${BASE_URL}/authUser/delete-account`,
        {
          method: 'DELETE',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ password }),
        },
        user.token
      );

      const data = await response.json();
      if (response.ok) {
        addNotification(t('deleteAccountPage.success'), 'success', 5000);
        logoutUser(); // Use the centralized logout function
        navigate(`/${lang}`);
      } else {
        addNotification(t('deleteAccountPage.failure', { error: data.message || t('deleteAccountPage.genericError') }), 'error');
      }
    } catch (err) {
      addNotification(t('deleteAccountPage.networkError'), 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    console.log('user.creditPoints:', user.creditPoints);
    const hasCredits = user.creditPoints > 0;
    let confirmationMessage = t('deleteAccountPage.confirmMessage');

    if (hasCredits) {
      confirmationMessage = t('deleteAccountPage.confirmMessageWithCredits', { count: user.creditPoints });
    }

    addNotification(confirmationMessage, 'warning', 0, true, [
      { text: t('deleteAccountPage.confirmButton'), onClick: proceedWithDeletion, className: 'delete-btn' },
      { text: t('deleteAccountPage.cancelButton'), onClick: () => {} },
    ]);
  };

  return (
    <div className="delete-account-page-container">
      <div className="delete-account-container">
        <h2>{t('deleteAccountPage.title')}</h2>
        <p className="warning-text">{t('deleteAccountPage.warningText')}</p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="deletePassword">{t('deleteAccountPage.passwordLabel')}</label>
            <input type="password" id="deletePassword" name="deletePassword" value={password} onChange={(e) => setPassword(e.target.value)} required disabled={isSubmitting} />
          </div>
          <div className="button-group">
            <button type="submit" className="delete-btn" disabled={isSubmitting}>
              {isSubmitting ? t('deleteAccountPage.deletingButton') : t('deleteAccountPage.deleteButton')}
            </button>
            <button type="button" className="cancel-btn" onClick={() => navigate(`/${lang}/preferences`)} disabled={isSubmitting}>
              {t('deleteAccountPage.cancelButton')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DeleteAccount;
